<template>
  <div class="tw-pt-4 tw-pl-6 tw-pr-6 tw-opacity-100 tw-text-center">
    <div
      class="
        tw-text-sm
        tw-font-medium
        tw-rounded-md
        tw-bg-gray-100
        tw-p-4
        tw-text-sf-gray-dark
      "
    >
      {{ I18n.t('communication.empty_state.account_message') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import useI18n from '@app/shared/vue/composables/use-I18n'

const I18n = useI18n()
</script>
